import apiService from 'src/shared/config/apiService';
import handleAxiosError from 'src/shared/utils/handleAxiosError';

// backend/notifications/serializers.py > BookingTypeSerializer
export interface BookingType {
  id: number;
  name: string;
  calendly_url: string;
  effective_calendly_url: string;
  task_type_on_call_booking: number | null;
  publish_update_on_creation: boolean;
}

// backend/notifications/serializers.py > BookingSerializer
export interface Booking {
  id: string;
  organization: number;
  user: object;
  product: string | null;
  product_name: string | null;
  tasks: string[];
  booking_type: BookingType | null;
  status: string;
  booking_url: string;
  scheduled_at: string | null;
  created_at: string;
  tags: string[];
}

export interface GetBookingsParams {
  organizationId: number;
  productId?: string;
  taskId?: string;
  bookingTypeNames?: string[];
  statuses?: string[];
  includeAllStatuses?: boolean;
}

export const getBookings = async (
  params: GetBookingsParams
): Promise<Booking[]> => {
  try {
    const searchParams = new URLSearchParams();

    searchParams.set('organization_id', String(params.organizationId));
    if (params.productId) searchParams.set('product_id', params.productId);
    if (params.taskId) searchParams.set('task_id', params.taskId);
    if (params.includeAllStatuses) {
      searchParams.set('include_all_statuses', 'true');
    }
    params.bookingTypeNames?.forEach((name) =>
      searchParams.append('booking_type_name', name)
    );
    params.statuses?.forEach((s) => searchParams.append('status', s));

    const response = await apiService.get<Booking[]>(
      `/bookings/?${searchParams.toString()}`
    );

    return response.data;
  } catch (error) {
    throw handleAxiosError(error);
  }
};
